import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/configureStore';
import history from './utils/history';
import { initialize } from '@plat/domain-api';
import { initApiConfiguration as initBaselineClientApis } from '@fluke/baseline-client-apis';
import { baseURLEnum } from '@fluke/baseline-client-apis';
import logger from './utils/logger';

const MOUNT_NODE = document.getElementById('root');

window.BASELINE = {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_PENDO_API_KEY: process.env.REACT_APP_PENDO_API_KEY,
};

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  MOUNT_NODE,
);

reportWebVitals();
initialize();

let baseURLS = {};
baseURLS[baseURLEnum.USER_STORE] = process.env.REACT_APP_USER_STORE_URL;
baseURLS[baseURLEnum.IMAGE_ACCESS] = process.env.REACT_APP_BASE_API_URL;
baseURLS[baseURLEnum.REPORT_ACCESS] = process.env.REACT_APP_REPORT_API_URL;
baseURLS[baseURLEnum.VISOR_API] = process.env.REACT_APP_VISOR_API_BASE_URL;
baseURLS[baseURLEnum.COLUMBIA] = process.env.REACT_APP_COLUMBIA_API_BASEURL;
baseURLS[baseURLEnum.COLUMBIA_INFO] = process.env.REACT_APP_BASELINE_COLUMBIA_INFO_API_URL;
baseURLS[baseURLEnum.BASELINE_JWT_SERVICE] = process.env.REACT_APP_BASELINE_JWT_URL;

initBaselineClientApis(
  process.env.REACT_APP_REGION,
  process.env.REACT_APP_USER_POOL_ID_COLUMBIA,
  process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID_COLUMBIA,
  baseURLS,
  logger,
);
